meedy.controller('meedy.secondDiagnosisListController', ['$scope', '$state', '$sce', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.secondDiagnosisModel', 'meedyConfig',
    function ($scope, $state, $sce, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, secondDiagnosisModel, config) {

        function setData() {
            $scope.diagnoses = [];
            $scope.criteria = new SecondDiagnosisDataGridMeedyCriteria();
            $scope.criteria.sortColumns = [{columnName: "creationDate", descending: true}];

            $scope.columns = [
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.CREATION_DATE'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-date.html',
                    field: 'creationDate',
                    sorting: true
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.TYPE'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-type.html',
                    field: 'type'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.FIRST_NAME'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-patient.html',
                    field: 'firstName'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.LAST_NAME'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-patient.html',
                    field: 'lastName'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.PESEL'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-patient.html',
                    field: 'identifier'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.PHONE'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-patient.html',
                    field: 'mainPhone'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.SECOND_DIAGNOSIS.STATUS'),
                    cellTemplate: 'meedy/application/view/app/secondDiagnosis/grid-templates/data-secondDiagnosis-list-status.html',
                    sorting: true,
                    field: 'status'
                }
            ];

            $scope.filters = [
                //{type : 'date', value : undefined, fieldName : 'createDate', label : 'T.MEEDY.MODULE.SECOND_DIAGNOSIS.CREATION_DATE'},
                {type : 'select', value : null, fieldName : 'status', label : 'T.MEEDY.MODULE.SECOND_DIAGNOSIS.STATUS', options: [
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.VALIDATED', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.VALIDATED},
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.DONE', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.DONE},
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.MISSING_DATA', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.MISSING_DATA},
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.IN_PROGRESS', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.IN_PROGRESS},
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.REJECTED_BY_PHYSICIAN', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.REJECTED_BY_PHYSICIAN},
                    {label : 'T.MEEDY.ENUM.SECOND_DIAGNOSIS_STATUS.REJECTED_BY_PHYSICIAN_INCOMPETENCE', value : Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.REJECTED_BY_PHYSICIAN_INCOMPETENCE}
                ]}
            ];

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.diagnoses = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            });

            $scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.TOKEN.SUCCESS, function(event, token) {
                //var a         = document.createElement('a');
                //a.href        = config.FILE_DOWNLOAD_PREFIX + '/servlet/download?token=' + token + '&idInvoice=' + $scope.selectedInvoiceId;
                //a.target      = '_blank';
                //a.download    = 'Faktura';
                //
                //document.body.appendChild(a);
                //a.click();

                secondDiagnosisModel.download(token);
            });


            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.downloadPDF = function(secondDiagnosis) {
                $scope.selectedInvoiceId = secondDiagnosis.id;
                secondDiagnosisModel.token(secondDiagnosis.id, {generatedFileType : Enum.MEEDY.GENERATED_FILE_TYPE.COMMITTAL});
            };


            $scope.criteriaChanged = function() {
                secondDiagnosisModel.getDataPage($scope.criteria);
            };

            $scope.viewSecondDiagnosis = function(secondDiagnosis) {
                $state.go(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.EDIT, {id: secondDiagnosis.id});
            }
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SECOND_DIAGNOSIS');
        }

        function initialize() {
            secondDiagnosisModel.getDataPage($scope.criteria);
            applicationModel.fillViewportMode = true;
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
